import { createBrowserRouter } from 'react-router';
import RootLayout from './RootLayout';
import ProtectedLayout from './ProtectedLayout';
import PublicLayout from './PublicLayout';
import ErrorPage from './ErrorPage';

import HomePage from '../pages/HomePage';
import MenuPage from '../pages/MenuPage';
import MenuItemDetailPage from '../pages/MenuItemDetailPage';
import ComboDetailPage from '../pages/ComboDetailPage';
import CheckoutPage from '../pages/CheckoutPage';
import ViewCartPage from '../pages/ViewCartPage';
import ContactPage from '../pages/ContactPage';
import BlogPage from '../pages/BlogPage';
import StoryPage from '../pages/StoryPage';
import EventsPage from '../pages/EventsPage';
import GalleryPage from '../pages/GalleryPage';
import LocationSelector from '../components/LocationSelector';

export const router = createBrowserRouter([
  {
    Component: RootLayout,
    errorElement: <ErrorPage />,
    children: [
      // Normal Mode Routes (/)
      {
        path: "/",
        Component: ProtectedLayout,
        children: [
          { index: true, Component: HomePage },
          { path: "menu", Component: MenuPage },
          { path: "menu-item/:itemId", Component: MenuItemDetailPage },
          { path: "combo/:comboId", Component: ComboDetailPage },
          { path: "checkout", Component: CheckoutPage },
          { path: "cart", Component: ViewCartPage },
          { path: "contact", Component: ContactPage },
          { path: "blog", Component: BlogPage },
          { path: "our-story", Component: StoryPage },
          { path: "gallery", Component: GalleryPage },
          { path: "events", Component: EventsPage },
        ],
      },

      // Preview Mode Routes (/:id/preview)
      // For template previews only
      {
        path: "/:id/preview",
        Component: ProtectedLayout,
        children: [
          { index: true, Component: HomePage },
          { path: "menu", Component: MenuPage },
          { path: "menu-item/:itemId", Component: MenuItemDetailPage },
          { path: "combo/:comboId", Component: ComboDetailPage },
          { path: "checkout", Component: CheckoutPage },
          { path: "cart", Component: ViewCartPage },
          { path: "contact", Component: ContactPage },
          { path: "blog", Component: BlogPage },
          { path: "our-story", Component: StoryPage },
          { path: "gallery", Component: GalleryPage },
          { path: "events", Component: EventsPage },
        ],
      },

      // Edit Mode Routes (/:id/preview/edit)
      // Separate route structure for restaurant editing
      {
        path: "/:id/preview/edit",
        Component: ProtectedLayout,
        children: [
          { index: true, Component: HomePage },
          { path: "menu", Component: MenuPage },
          { path: "menu-item/:itemId", Component: MenuItemDetailPage },
          { path: "combo/:comboId", Component: ComboDetailPage },
          { path: "checkout", Component: CheckoutPage },
          { path: "cart", Component: ViewCartPage },
          { path: "contact", Component: ContactPage },
          { path: "blog", Component: BlogPage },
          { path: "our-story", Component: StoryPage },
          { path: "gallery", Component: GalleryPage },
          { path: "events", Component: EventsPage },
        ],
      },

      // Public Routes
      {
        Component: PublicLayout,
        children: [
          { path: "select-location", Component: LocationSelector },
        ],
      },
    ],
  },
]);
